import wiwUser from './wiw-user';

export default new wiwUser();
